import React from "react";

import styled from "styled-components/macro";

import RecurringIntervalOptions from "Payments/Shared/RecurringIntervalOptions";

import { colors } from "UI/colors";

import { useRecurringGifts } from "../../../RecurringGiftsContext";

export default function Interval() {
  const { state, dispatch } = useRecurringGifts();
  const interval = state.editModal?.giftWithEdits?.interval;
  const { isSubmitting, editPanelValidationError } = state.editModal;

  const onSelect = (newInterval) => {
    dispatch({
      type: "updateInterval",
      payload: newInterval.id,
    });

    if (editPanelValidationError === "interval") {
      dispatch({ type: "clearEditPanelValidationError" });
    }
  };

  return (
    <Wrapper>
      <IconWrapper>
        <Icon className="fa-sync-alt fad" />
      </IconWrapper>
      <IntervalText>
        Recurring:{" "}
        <RecurringIntervalOptions
          selected={{
            id: interval?.toLowerCase() || "",
            label: interval,
          }}
          onSelect={onSelect}
          fundColor={colors.fnBlue}
          disabled={isSubmitting}
        />
      </IntervalText>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  width: 60px;
  min-width: 60px;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
`;

const IntervalText = styled.div`
  font-weight: 400;
`;
